<template>
  <div class="c-add-visit" @click="close">
    <n-loader :loading="$var('load')" />
    <div class="form" @click.stop>
      <div class="title main">Создание посещения</div>

      <div class="time-selector-wrapper">
        <div class="title">
          Укажите время посещения:
        </div>
        <div class="time-selector">
          <n-input
            :placeholder="'00'"
            type="text"
            class="new-time-input"
            :maxlength="2"
            v-bind="$form.input('hour')"
            @input="onTimeInput('hour', 23)"
            @blur="onBlurPad('hour')"
          />
          :
          <n-input
            :placeholder="'00'"
            type="text"
            class="new-time-input"
            :maxlength="2"
            v-bind="$form.input('minute')"
            @input="onTimeInput('minute', 59)"
            @blur="onBlurPad('minute')"
          />
        </div>
      </div>

      <div class="time-selector-wrapper">
        <div class="title">
          Укажите дату посещения:
        </div>
        <c-date-picker v-if="preDate === null" :date.sync="date" />
        <c-date-picker v-else :pre-date="[preDate]" :date.sync="date" />
      </div>

      <div class="time-selector-wrapper">
        <div class="title">
          Укажите точку контроля:
        </div>
        <n-select class="new-select" readonly :data="locationPoints" :value.sync="locationPoint" />
      </div>

      <div v-if="user.ableChooseVisitDay" class="field check-box" @click="sendInDate = !sendInDate">
        <div class="box">
          <img v-show="!sendInDate" :src="imgDone" alt="">
        </div>
        <div class="title">
          Автоопределение даты учета посещения
        </div>
      </div>
      <div v-show="sendInDate" class="time-selector-wrapper">
        <div class="title">
          Дата учета:
        </div>
        <c-date-picker :pre-date="[newInDate]" :date.sync="newInDate" />
      </div>
      <div v-if="$var('danger')" class="time-selector-wrapper">
        <div class="title danger">
          {{ $var('danger') }}
        </div>
      </div>
      <div class="buttons">
        <n-button class="cancel" @click="close">Отмена</n-button>
        <n-button @click="add">Добавить</n-button>
      </div>
    </div>
  </div>
</template>

<script>

import imgDone from '../../assets/done.svg'

export default {
  name: 'CAddVisit',
  props: {
    userId: {
      type: Number,
      required: true,
    },
    locationPoints: {
      type: Array,
      required: true,
    },
    preDate: {
      type: Date,
      default: null,
    },
    user: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      imgDone,
      companyId: $app.auth.user().companyId,
      hours: [],
      minutes: [],
      locationPoint: {},
      newInDate: new Date,
      sendInDate: false,
      date: null,
    }
  },
  created() {
    if (this.preDate) {
      this.date = this.preDate
    }
    this.generateHours()
    this.$form.init({
      hour: {},
      minute: {},
    })
    this.$form.rules({
      hour: [ 'required', ],
      minute: [ 'required', ],
    })
  },
  methods: {
    onTimeInput(field, max) {
      let value = this.$form.get(field)

      value = value.replace(/\D/g, '')

      if (value.length > 2) {
        value = value.slice(0, 2)
      }

      const num = parseInt(value || '0')

      if (num > max) {
        value = max.toString().padStart(2, '0')
      }

      this.$form.set(field, value)
    },
    onBlurPad(field) {
      const val = this.$form.get(field)
      if (val !== undefined && val !== null && val.length === 1) {
        const padded = val.padStart(2, '0')
        this.$form.set(field, padded)
      }
    },
    close() {
      this.$emit('update:show', false)
    },
    generateHours() {
      this.hours = Array.from({ length: 24, }, (_, i) => ({
        value: i > 9?i:'0'+(i),
        title: i > 9?i:'0'+(i),
      }))
      this.minutes = Array.from({ length: 60, }, (_, i) => ({
        value: i > 9?i:'0'+(i),
        title: i > 9?i:'0'+(i),
      }))
    },
    add() {
      const data = {
        date: new Date(this.date.setHours(Number(this.$form.get('hour')), Number(this.$form.get('minute')), 0, 0)),
        locationPointId: this.locationPoint.id,
      }

      if (this.sendInDate) {
        data.inDate = this.newInDate
      }

      if (this.$form.check() && this.date && Object.keys(this.locationPoint).length > 0) {
        this.$var('load', true)
        $api.visits.create(this.companyId, this.userId, data).then(() => {
          this.close()
        }).finally(() => {
          this.$var('load', false)
        })
      } else {
        this.$var('danger', 'Есть неправильно заполненные поля')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-add-visit {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: #00000080;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;

  :deep() {
    .n-select {
    }
  }

  .field {
    flex: 1;
    display: flex;
    margin-bottom: 15px;
    .n-input {
      margin-left: 25px;
      min-width: 100px;
    }
    &.check-box {
      display: flex;
      align-items: center;
      width: 100%;
      .box {
        margin-right: 15px;
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        border: 1px solid #000000;
        padding: 1px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .title {
        justify-content: left;
        font-size: 14px;
        margin-bottom: 0;
      }
    }
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .n-button {
      background-color: var(--primary);
      color: #FFFFFF;
      border: none;
      border-radius: 12px;
      height: 48px;
      padding: 0 24px;

      &.cancel {
        background-color: #ffffff;
        color: var(--primary);
        font-weight: 700;
        border: 1px solid var(--primary);
      }
    }
  }
  .buttons {
    width: 100%;
  }
  .form {
    padding: 15px;
    z-index: 1001;
    min-width: 460px;
    min-height: 200px;
    border-radius: 16px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: stretch;
    .title {
      font-size: 16px;
      color: #000000;
      font-weight: 500;
      &.main {
        margin-bottom: 15px;
      }
    }
    .time-selector-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .title {
        &.danger {
          width: 100%;
          color: red;
          text-align: center;
        }
        margin-right: 15px;
        font-weight: normal;
        font-size: 14px;
        color: #000000;
      }
    }

    .new-time-input {
      width: 50px;
      border-radius: 12px;
      text-align: center;
      box-shadow: 0 0 0 1px #e0e3f0;
      margin: 0 2px;

      ::v-deep {
        .n-input {
          border: none !important;
        }

        .n-content {
          width: 50px;
          height: 40px;
          padding: 6px 10px 6px 15px;
        }
      }
    }

    .time-selector {
      display: flex;
      align-items: center;
      justify-content: start;
      ::v-deep {
        .n-select {
          .v-select {
            padding: 2px;
          }
          .n-icon {
            display: none;
          }
          .n-text {
            text-align: center;
          }
          &:first-child {
            margin-right: 5px;
          }
          &:last-child {
            margin-left: 5px;
          }
          width: 60px;
          .n-content {
            padding: 0;
          }
          .n-icon {
            margin: 0 !important;
          }
          .n-popup-content {
            width: 60px;
            .n-dropdown-item {
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .n-item {
              text-align: center;
            }
          }
          .n-wrapper {
            padding: 0 5px;
            width: 60px;
          }
          .n-dropdown {
            width: 60px;
          }
        }
      }
    }
  }
}
</style>
